import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTheme } from '../../context/ThemeContext';
import PackagingAndProtection from '../../components/PackagingAndProtection';
import { useFormStore } from '../../stores/formData';
import { ShieldCheck, ChevronDown, ChevronUp } from 'lucide-react';

const CoverageCard = ({ onInsuranceChange, isExpanded = false, updatingCart = false }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [expanded, setExpanded] = useState(isExpanded);

  const formData = useFormStore((state) => state.formData);

  const containerClassName = clsx(
    'rounded-lg border transition-all duration-200',
    {
      'bg-slate-800 border-slate-700': isDark,
      'bg-gray-100 border-gray-300': !isDark
    }
  );

  const headerClassName = clsx(
    'flex items-center justify-between p-4 cursor-pointer',
    {
      'hover:bg-slate-700': isDark,
      'hover:bg-gray-200': !isDark
    }
  );

  const titleClassName = clsx(
    'text-lg font-medium flex items-center gap-2',
    {
      'text-slate-200': isDark,
      'text-gray-900': !isDark
    }
  );

  const sectionClassName = clsx(
    'bg-white p-3 space-y-4 border-t rounded-br-lg rounded-bl-lg',
  );

  const sectionHeaderClassName = clsx(
    'text-sm font-semibold flex items-center gap-2',
    {
      'text-slate-300': isDark,
      'text-gray-700': !isDark
    }
  );

  const iconClassName = clsx(
    'w-4 h-4',
    {
      'text-slate-400': isDark,
      'text-gray-500': !isDark
    }
  );

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={containerClassName}>
      <div className={headerClassName} onClick={toggleExpanded}>
        <div className="flex items-center gap-1">
          <ShieldCheck className="h-4 w-4" />
          <h3 className={titleClassName}>
            Coverage
          </h3>
        </div>
        {expanded ? (
          <ChevronUp className={iconClassName} />
        ) : (
          <ChevronDown className={iconClassName} />
        )}
      </div>
      {expanded && formData.legs && formData.legs.length > 0 && (
        <div className={sectionClassName}>
          {formData.legs.map((leg, index) => (
            <div key={index} className="mt-4">
              <div className="flex flex-col gap-3">
                <h3 className={sectionHeaderClassName}>Leg {index + 1}</h3>
                {formData?.legs?.[index]?.selectedProducts?.length && (
                  <PackagingAndProtection
                    legIndex={index} 
                    onInsuranceChange={onInsuranceChange}
                    updatingCart={updatingCart}
                  />
                )}
              </div>
            </div>
          ))}      
        </div>
      )}
    </div>
  );
};

CoverageCard.propTypes = {
  onInsuranceChange: PropTypes.func,
  isExpanded: PropTypes.bool,
  updatingCart: PropTypes.bool
};

export default CoverageCard;